<template>
  <div class="q-pa-md">
    <PageHeader title="Detalhe da Atividade" />

    <div v-if="atividade" class="row q-my-md container-atividade-inputs">
      <div
        class="row col-12 q-gutter-x-sm text-brand-5 text-weight-bold text-body"
      >
        <div class="col-md-2 col-sm-5 col-xs-5 container-input-unidade">
          <div class="q-ml-sm titulo-input">Unidade</div>
          <q-input
            outlined
            v-model="atividade.unidadeNome"
            class="bg-brand-7 input"
            dense
            disable
          />
        </div>
        <div class="col-md-2 col-sm-6 col-xs-6">
          <div class="q-ml-sm titulo-input">Nome da Atividade</div>
          <q-input
            outlined
            v-model="atividade.nome"
            class="bg-brand-7 input"
            dense
            disable
          />
        </div>
        <div>
          <div class="q-ml-sm titulo-radio">
            Atividade <span class="text-red">Crítica ?</span>
          </div>
          <q-radio
            v-model="atividade.critico"
            label="Sim"
            disable
            color="brand-4"
            class="radio"
            v-bind:val="true"
          ></q-radio>
          <q-radio
            v-model="atividade.critico"
            v-bind:val="false"
            label="Não"
            color="brand-4"
            class="radio"
            disable
          ></q-radio>
        </div>
        <div class="q-ml-md">
          <div class="q-ml-sm titulo-radio">
            Atividade <span class="text-red">Obrigatória ?</span>
          </div>
          <q-radio
            v-model="atividade.obrigatorio"
            label="Sim"
            disable
            color="brand-4"
            class="radio"
            v-bind:val="true"
          ></q-radio>
          <q-radio
            v-model="atividade.obrigatorio"
            v-bind:val="false"
            label="Não"
            color="brand-4"
            class="radio"
            disable
          ></q-radio>
        </div>
      </div>

      <div class="col-12 q-mt-lg">
        <adicionar-pergunta
          :unidadeId="atividade.unidadeId"
          :atividadeId="atividade.atividadeId"
          @closing="buscarDetalheAtividade"
        />
      </div>

      <div class="col-12 q-my-lg">
        <p class="text-brand-5 text-weight-bold q-ml-md titulo-table">
          Lista de Perguntas
        </p>
        <q-table
          table-header-class="bg-accent text-weight-bold"
          :rows="atividade.perguntas"
          :columns="columns"
          :grid="$q.screen.lt.sm"
          row-key="perguntaId"
          class="tabela-tamanho-fixo"
          dense
          :rows-per-page-options="[0]"
          hide-bottom
          flat
        >
          <template v-slot:item="props">
            <div class="col-xs-12 col-sm-6 col-md-4">
              <div
                class="row card text-grid-table text-brand-5 text-weight-bold q-pa-xs"
              >
                <div class="row col-12 items-center justify-between">
                  <span class="col-9">{{ props.row.descricao }}</span>
                  <q-btn
                    icon="remove_circle_outline"
                    color="red"
                    flat
                    size="md"
                    @click="removerPergunta(props.row.perguntaId)"
                  />
                </div>
              </div>
            </div>
          </template>
          <template v-slot:body-cell-descricao="props">
            <q-td class="text-brand-4 text-weight-medium" :props="props">
              {{ props.row.descricao }}
            </q-td>
          </template>
          <template v-slot:body-cell-remover="props">
            <q-td :props="props">
              <q-btn
                color="white"
                text-color="red"
                icon="remove_circle_outline"
                flat
                label="Remover"
                no-caps
                @click="removerPergunta(props.row.perguntaId)"
              />
            </q-td>
          </template>
        </q-table>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";

import AdicionarPergunta from "../components/AdicionarPergunta.vue";
import PageHeader from "../../../../components/PageHeader.vue";

export default {
  components: { AdicionarPergunta, PageHeader },
  setup() {
    const atividade = ref(null);
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const quasar = useQuasar();
    const columns = [
      {
        name: "descricao",
        required: true,
        label: "Pergunta",
        align: "left",
        field: (row) => row.descricao,
      },
      {
        name: "remover",
        required: true,
        label: "Remover",
        align: "center",
        field: "atividadeId",
      },
    ];

    const buscarDetalheAtividade = async () => {
      const resposta = await store.dispatch("pdt/buscarDetalheAtividade", {
        unidadeId: route.params.unidadeId,
        atividadeId: route.params.atividadeId,
      });

      atividade.value = resposta.data.resultado.dados;
    };

    const removerPergunta = async (perguntaId) => {
      await store.dispatch("pdt/removerPergunta", {
        unidadeId: route.params.unidadeId,
        atividadeId: route.params.atividadeId,
        perguntaId,
      });
      quasar.notify({
        message: "Pergunta removida",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
          },
        ],
      });

      buscarDetalheAtividade();
    };

    const voltar = () => {
      router.push({ name: "pdt-unidade" });
    };

    onMounted(buscarDetalheAtividade);

    return {
      atividade,
      columns,
      buscarDetalheAtividade,
      removerPergunta,
      voltar,
    };
  },
};
</script>

<style scoped>
.icon {
  cursor: pointer;
}
.titulo-table {
  font-size: 17px;
}
.cursor {
  cursor: pointer;
}
@media (max-width: 600px) {
  .titulo-pagina {
    font-size: 14px;
  }
  .container-atividade-inputs {
    margin: 0px;
  }
  .cursor {
    font-size: 14px !important;
    margin-top: 8px !important;
  }
  .titulo-input {
    margin: 0px 0px 0px 0px;
    font-size: 12px;
  }
  .titulo-radio {
    font-size: 12px;
    margin: 17px 0px 0px 0px;
  }
  .input {
    font-size: 12px;
  }
  .radio {
    font-size: 12px;
  }
  .titulo-table {
    font-size: 14px;
    margin: 10px 0px 18px 0px;
  }
  .card {
    border: 1px solid #707070;
    font-weight: bold;
  }
  .text-grid-table {
    font-size: 12px;
  }
}
</style>
